import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as AhorroYCreditoActions from "app/@Content/components/AhorroYCredito/store/actions";
import TextTitleWithDownloads from "@components/TextTitleWithDownloads/TextTileWithDownloads";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";

const BORDER_TOP_COLOR = "#d7de00";

function Reglamentos(props) {
  const dispatch = useDispatch();

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { token } = useSelector(({ Base }) => Base.Token);

  const { reglamentos } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    dispatch(AhorroYCreditoActions.getReglamentos(token));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const defRoute = rutas?.filter((route) => route?.name === "Reglamentos");
  const reglamentosItems = (
    <>
      {reglamentos && (
        <TextTitleWithDownloads
          title={reglamentos?.aCReglamento[0]?.titulo?.html}
          text={reglamentos?.aCReglamento[0]?.descripcion?.html}
          borderTopColor={BORDER_TOP_COLOR}
          downloadSections={[
            {
              titulo: "Reglamentos",
              archivosDescargables: {
                contentItems: [
                  ...reglamentos?.aCReglamentoArchivosDescargables,
                ],
              },
            },
          ]}
        />
      )}
    </>
  );

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.h1} />
      {reglamentosItems}
    </>
  );
}

export default Reglamentos;
